/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseCostTrendWidgetConfigurationModel extends models.BaseGroupByDataWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("BaseCostTrendWidgetConfigurationModel");
    }

    getFixupPrototypeFunction() { return BaseCostTrendWidgetConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<BaseCostTrendWidgetConfigurationModel>): BaseCostTrendWidgetConfigurationModel {
        let obj = Object.assign(new BaseCostTrendWidgetConfigurationModel(), model);
        BaseCostTrendWidgetConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseCostTrendWidgetConfigurationModel>): BaseCostTrendWidgetConfigurationModel {
        if (!model) return null;
        return BaseCostTrendWidgetConfigurationModel.newInstance(<BaseCostTrendWidgetConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseCostTrendWidgetConfigurationModel) {
        if (!obj) return;

        models.BaseCostTrendWidgetConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseCostTrendWidgetConfigurationModel): boolean {
        if (models.BaseGroupByDataWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BaseCostTrendWidgetConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    showVarianceColumn: boolean;

}
